module.exports = __webpack_public_path__ + "static/media/Founders Legacy Society.cd7e9619.png";